var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvoiceWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "38px",
    viewBox: "0 0 32 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ikonn_faktura_hvit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Elementer-med-oppf\\xF8rsel",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementer",
    transform: "translate(-1891.000000, -2128.000000)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ikonn_faktura_hvit",
    transform: "translate(1891.000000, 2128.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ikonn_faktura-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ikon---faktura-Copy-4",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5,0.75 C1.08578644,0.75 0.75,1.08578644 0.75,1.5 L0.75,36.5 C0.75,36.9142136 1.08578644,37.25 1.5,37.25 L30.5,37.25 C30.9142136,37.25 31.25,36.9142136 31.25,36.5 L31.25,1.5 C31.25,1.08578644 30.9142136,0.75 30.5,0.75 L1.5,0.75 Z",
    id: "Rectangle-15-Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,9.5 L24.5,9.5",
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,17.5 L17.5,17.5",
    id: "Line-Copy",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,22.5 L17.5,22.5",
    id: "Line-Copy-3",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,27.5 L17.5,27.5",
    id: "Line-Copy-5",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5,17.5 L24.5,17.5",
    id: "Line-Copy-2",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5,22.5 L24.5,22.5",
    id: "Line-Copy-4",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5,27.5 L24.5,27.5",
    id: "Line-Copy-6",
    strokeLinecap: "square"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceWhite);
export default __webpack_public_path__ + "static/media/invoice-white.343c06400b90f9fe4cad169d8725d18c.svg";
export { ForwardRef as ReactComponent };